// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.product-describe[data-v-37983056] {
}
[data-v-37983056] .van-cell {
  line-height: 1em !important;
}
[data-v-37983056] .van-collapse-item__content {
  padding: 0;
  background-color: transparent;
}
[data-v-37983056] .van-collapse-item__wrapper {
  border: none;
}
[data-v-37983056] .van-collapse-item {
  border: none;
}
.collapse-icon[data-v-37983056] {
  transition: transform 0.3s ease;
}
[data-v-37983056] .van-collapse-item--expanded .collapse-icon {
  transform: rotate(180deg);
}
.value-text[data-v-37983056] {
  white-space: pre-line;
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
